import PropTypes from 'prop-types';
import { FormGroup, Label, TextField } from '@celltrak/ui-components';
import noop from 'lodash/noop';

import { credentialForm } from '../../constants';

import styles from './BusinessNameField.module.scss';

const BusinessNameField = ({ value, onChange, disabled }) => {
  const handleValueChange = event => onChange(event);

  return (
    <div className={styles.businessField}>
      <FormGroup>
        <Label size="sm" for={credentialForm.businessNameId}>
          {credentialForm.businessNameLabel}
        </Label>
        <TextField
          id={credentialForm.businessNameId}
          size="sm"
          value={value}
          onChange={handleValueChange}
          disabled={disabled}
        />
      </FormGroup>
    </div>
  );
};

BusinessNameField.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
};

BusinessNameField.defaultProps = {
  value: '',
  onChange: noop,
  disabled: false,
};

export default BusinessNameField;
